import React from 'react';
import { Footer } from '../../components/Footer/Footer';
import { useStyles } from './css';
import { HeaderAppBar } from '../../components/HeaderAppBar/HeaderAppBar';

export const AppStore = ({ children }: { children: React.ReactNode }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <HeaderAppBar />
            <main>{children}</main>
            <Footer />
        </div>
    );
};
